"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDelayedLoading = exports.MINIMUM_DELAY = void 0;
var _react = require("react");
const MINIMUM_DELAY = exports.MINIMUM_DELAY = 750;
/**
 * Hook to ensure that the loading state lasts for at least a certain amount of time.
 * This is useful to avoid flickering loading indicators.
 *
 * @param delay The minimum time to show the loading indicator, default value is 750 (ms). When set to 0, fake loading will not be used.
 * @param loading The loading state
 *
 * @returns showLoading A boolean indicating whether the loading indicator should be shown
 *
 * @example
 * const { isLoading } = useDelayedLoading({ loading });
 *
 */ const useDelayedLoading = (param)=>{
    let { delay = MINIMUM_DELAY, loading } = param;
    const [fakeLoading, setFakeLoading] = (0, _react.useState)(false);
    const timeoutRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (loading && delay > 0) {
            setFakeLoading(true);
            timeoutRef.current = setTimeout(()=>{
                setFakeLoading(false);
            }, delay);
        }
    }, [
        delay,
        loading
    ]);
    // Clear the timeout when the component is unmounted
    (0, _react.useEffect)(()=>()=>{
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        }, []);
    return {
        isLoading: fakeLoading || loading
    };
};
exports.useDelayedLoading = useDelayedLoading;
